import { IChatAvitoState } from './interfaces'
import {
  CHAT_AVITO_LOADING,
  CHAT_AVITO_DATA,
  CHAT_AVITO_FAILED,
  CHAT_AVITO_ADD_ITEM,
  SET_ACTIVE_AVITO_CHAT_ID,
} from './actions'
import { IAvitoChat } from '../../pages/card-hr/new/ui/hr-chats/types'

const initialState: IChatAvitoState = {
  data: [],
  isLoading: false,
  error: '',
}

export const chatAvitoReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case CHAT_AVITO_LOADING:
      return {
        ...state,
        isLoading: true,
        error: '',
      }
    case CHAT_AVITO_DATA:
      return {
        ...state,
        data: payload,
        isLoading: false,
        error: '',
      }
    case CHAT_AVITO_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      }
    case CHAT_AVITO_ADD_ITEM:
      const newChatItem = payload as IAvitoChat
      const chats: IAvitoChat[] = state.data || []

      function mergeObjects(currData: IAvitoChat[], newChatItem: IAvitoChat): IAvitoChat[] {
        let foundMatchingChatId = false

        // Создаем новый массив чатов, где каждый чат - новый объект
        const updatedData = currData.map(chatItem => {
          if (chatItem.chat_id === newChatItem.chat_id) {
            foundMatchingChatId = true
            // Создаем новый объект чата с обновленным массивом сообщений
            return {
              ...chatItem,
              chat: [...chatItem.chat, ...newChatItem.chat],
              count_not_read: newChatItem.count_not_read,
            }
          }
          return chatItem
        })

        // Если чат не найден, добавляем его в конец
        if (!foundMatchingChatId) {
          return [...updatedData, newChatItem]
        }

        return updatedData
      }

      const newData = mergeObjects(chats, newChatItem)
      return {
        ...state,
        data: newData,
        isLoading: false,
        error: '',
      }
    case SET_ACTIVE_AVITO_CHAT_ID:
      return {
        ...state,
        activeChatId: payload,
      }
    default:
      return state
  }
}
